<div class="row py-0 my-0 align-items-center">
    <div class="col-2 py-0 my-0">
        <a class="text-info ms-2 me-0 my-0 py-0" data-bs-toggle="offcanvas" href="#offcanvasWinoWino" role="button" aria-controls="offcanvasWinoWino" *ngIf="offcanvasNeeded; else elseBlock">
            <span class="bi bi-arrow-right-square-fill fs-3 by-0 py-0 my-0"></span>
        </a>
        <ng-template #elseBlock>
            <span class="bi bi-arrow-right-square-fill text-white fs-3 by-0 py-0 my-0"></span>
        </ng-template>
    </div>
    <div class="col-7 py-0 my-0">
        <p class="display-6 text-primary my-0 py-0">{{pageTitle}}</p>
    </div>

    <div class="col-3 by-0 py-0 my-0 text-end">
        <!-- <img class="ms-0 my-0 me-2 pe-2 py-0" src="/assets/images/03_denomination_36.png" alt="grapes" title="grapes"> -->
        <img *ngIf="imageName" class="ms-0 my-0 me-2 pe-2 py-0 by-0" src="{{'/assets/images/' + imageName}}" alt="{{imageName}}" title="{{imageName}}">
    </div>
</div>
<hr class="my-2">
